// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { ReturnOrder, returnOrderSchema } from '@/return-order/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the send to 3PL API endpoint.
 */
const sendTo3PLResponseSchema = z.object({
  data: returnOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Sends a return order to the third-party logistics provider.
 *
 * This operation:
 * 1. Validates the order is in DRAFT status
 * 2. Places the order with the 3PL provider
 * 3. Updates the order status to PENDING
 *
 * @param returnOrderKey - The key of the return order to send
 * @returns The updated return order with status PENDING
 */
export async function sendReturnOrderTo3PL(
  returnOrderKey: string
): Promise<ReturnOrder> {
  const url = `/v1/return-order/${returnOrderKey}/send-to-3pl`;
  const response = await api.post(url, {});

  const { data } = await parseResponse(sendTo3PLResponseSchema, response.data, {
    schemaName: 'SendReturnOrderTo3PL',
    endpoint: url,
  });
  return data;
}
